var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"y-axis",style:({
    'left': _vm.left,
    'height': _vm.height,
    'z-index': _vm.zIndex,
  })},[_c('div',{staticClass:"y-axis-show",style:({
      'border-left-color': _vm.color,
      'border-left-style': _vm.type,
      'border-left-width': _vm.width + 'px',
    })})])
}
var staticRenderFns = []

export { render, staticRenderFns }